const cards = document.querySelectorAll('[data-card]');
Array.prototype.forEach.call(cards, card => {
    let down, up, link = card.querySelector('a[data-card-link]');
    card.onmousedown = () => down = +new Date();
    card.onmouseup = () => {
        up = +new Date();
        if ((up - down) < 200) {
            if (link) {
                link.click();
            }
        }
    }
});